import { Component, inject, type OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '@infra/error-handling/alert.service';
import { AuthService } from '@infra/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: true,
})
export class LoginComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly alertService = inject(AlertService);

  ngOnInit(): void {
    if (!this.authService.tokenValid) {
      if (this.authService.isInUnrecoverableErrorState) {
        // This is likely due to the Auth0 ID not being set to the user in the database.
        // So technically the user is authenticated by Auth0, but not by the backend.
        // To fix this, the user needs to be recreated or manually set the ExternalUserId to the Auth0 ID in the User table.
        const timeToWaitInMilliseconds = 3000;

        this.alertService.error(
          'Something went wrong during the login procedure. Please contact customer support for assistance.',
          timeToWaitInMilliseconds
        );

        setTimeout(() => {
          this.authService.logout();
        }, timeToWaitInMilliseconds);
      } else {
        this.authService.login();
      }
    } else {
      const redirectUrl = this.getRedirectUrl();
      if (redirectUrl) {
        this.router.navigate([redirectUrl]);
      }
    }
  }

  private getRedirectUrl(): string | null {
    if (this.authService.isGlobalAdmin) {
      return '/admin';
    } else if (this.authService.isAgentAdmin) {
      return this.authService.companyUrl;
    } else if (this.authService.isCompanyUser) {
      return this.authService.companyUrl;
    }

    return null;
  }
}
